import { render, staticRenderFns } from "./bankTransfer.vue?vue&type=template&id=76328a41&scoped=true&lang=pug"
import script from "./bankTransfer.vue?vue&type=script&lang=js"
export * from "./bankTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76328a41",
  null
  
)

export default component.exports